<template>
  <div ref="container" class="table-breadcrubms">
    <button
      v-if="submenuToggleIsVisible"
      type="button"
      class="submenu-toggle-button"
      @click.stop="submenuIsVisible = !submenuIsVisible"
    />
    <ul v-if="submenuIsVisible" v-click-outside="onClickOutsideSubmenu" class="submenu">
      <template v-for="item in submenuList">
        <li :key="item.id" @click="handleItemClick(item.fkko_id)">
          <span class="title">{{ item.name }}</span>
          <span v-if="item.code" class="subtitle">{{ item.code }}</span>
        </li>
      </template>
    </ul>

    <ul ref="navList" class="nav-list">
      <template v-for="item in navList">
        <li :key="item.id">
          <span class="title" @click="handleItemClick(item.fkko_id)">{{ item.name }}</span>
          <span v-if="item.code" class="subtitle">{{ item.code }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import isEquel from "lodash.isequal";

export default {
  name: "TableBreadcrumbs",
  props: {
    navElements: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      submenuIsVisible: false,
      submenuToggleIsVisible: false,
      navList: [],
      submenuList: []
    };
  },
  watch: {
    navElements(newElements, oldElements) {
      if (isEquel(newElements, oldElements)) return;

      this.renderBreadcrumbs();
    }
  },
  mounted() {
    if (this.navElements.length > 0) {
      this.renderBreadcrumbs();
    }
  },
  methods: {
    async renderBreadcrumbs() {
      const navElements = this.navElements.slice().reverse();
      let breakId = null;

      this.navList = [];
      this.submenuList = [];

      for (let i = 0; i < navElements.length; i++) {
        const element = navElements[i];
        this.navList = [element, ...this.navList];

        await this.$nextTick();

        if (this.$refs.navList.offsetWidth >= this.$refs.container.offsetWidth - 120) {
          breakId = navElements[i].fkko_id;
          this.navList = this.navList.slice(1);
          break;
        }
      }

      if (breakId !== null) {
        const index = this.navElements.findIndex(element => element.fkko_id === breakId);

        if (index > -1) {
          this.submenuList = this.navElements.slice(0, index + 1);
          this.submenuToggleIsVisible = true;
        }
      } else {
        this.submenuToggleIsVisible = false;
      }
    },
    handleItemClick(id) {
      this.$emit("selected-item", id);
      this.submenuIsVisible = false;
    },
    onClickOutsideSubmenu() {
      this.submenuIsVisible = false;
    }
  }
};
</script>
